/**
 * Shared sleep timing for ambient wildlife.
 */

export const WILDLIFE_SLEEP_TIMING = {
  wakePauseMs: 1_200,
  frogWakePauseMs: 1_400,
  /** Reach sleep spot before switching pose. */
  arriveThreshold: 0.028,
} as const;

export function isNearPoint(
  a: { x: number; y: number },
  b: { x: number; y: number },
  worldAspect: number,
  threshold = WILDLIFE_SLEEP_TIMING.arriveThreshold,
): boolean {
  const dx = a.x - b.x;
  const dy = (a.y - b.y) / (worldAspect > 0 ? worldAspect : 1);
  return Math.hypot(dx, dy) <= threshold;
}
